module.exports = __webpack_public_path__ + "img/icon_orange.57a8a29.png";